import React, { Component } from 'react'
import { rutaImg } from "../../../global/js/funciones";
import ListarDatos from '../../general/ListarDatos';
import AppBarModal from "./../../general/AppBarModal";
import { BtnDetalle, BtnPermiso, BtnForm, BtnGestionar } from '../../general/BotonesAccion'
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import Generica from "./../../personas/generica/Generica";
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from '../../../global/imagenes/emma_w.png';
import {
  ESTADOS_BIENESTAR,
  TIPOS_SERV,
  TIPOS_SOL,
  PERMISO_TIPO_SOLICITUD,
  PERMISO_TIPO_SERVICIO,
  PERMISO_ESTADO,
} from '../helper';
import { fetchGestoresBienestar } from './services/bienestarDetalleService';


class BienestarPermisos extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cargando: true,
      personas: [],
      generica: {
        tipo: 0,
        id: 0,
      },
      modal: false,
      id_persona: null,
    }
  }

  async componentDidMount() {
    let personas = await this.obtenerGestoresBienestar();
    this.setState({ personas, cargando: false })
  }

  async obtenerGestoresBienestar() {
    return fetchGestoresBienestar();
  }

  acciones(data) {
    const onClickTipoSolicitud = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: PERMISO_TIPO_SOLICITUD, id: TIPOS_SOL } });
    const onClickTipoServicio = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: PERMISO_TIPO_SERVICIO, id: TIPOS_SERV } });
    const onClickEstado = (data) => this.setState({ id_persona: data.id, modal: true, generica: { tipo: PERMISO_ESTADO, id: ESTADOS_BIENESTAR } });
    return (
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>

        <BtnDetalle
          callback={() => onClickTipoSolicitud(data)}
          texto='Tipos'
          color='#2196f3'
        />

        <BtnGestionar
          callback={() => onClickTipoServicio(data)}
          texto='Servicios'
          color='#4caf50'
        />

        <BtnPermiso
          callback={() => onClickEstado(data)}
          texto='Estados'
        />

      </div>
    );
  }

  render(){
    let { modal, id_persona, generica, cargando, personas } = this.state;
    if (cargando) return <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" />;
    return (
      <div>
      <ListarDatos
        id="tbl_bienestar_permisos"
        titulo='Lista Gestores Bienestar Estudiantil'
        descargar="EMMA - GESTORES BIENESTAR ESTUDIANTIL"
        datos={personas}
        opciones={true}
        buscar={true}
        acciones={row => this.acciones(row)}
        avatarImg={true}
        avatar={({ identificacion }) => `${rutaImg}${identificacion}.jpg`}
        fila_principal={row => `${row.primer_nombre} ${row.segundo_nombre} ${row.primer_apellido} ${row.segundo_apellido}`.toUpperCase()}
        filas={[
            { 'mostrar': ({ correo }) => `${correo}`, 'id': 'correo', 'enLista': true },
            { 'mostrar': ({ identificacion }) => `${identificacion}`, 'id': 'identificacion', 'enLista': true }
        ]}
      />
        <Dialog open={modal} fullWidth={true} maxWidth='sm' onClose={() => this.setState({ modal: false })}>
          <AppBarModal titulo='¡ Lista Permisos !' mostrarModal={() => this.setState({ modal: false })} accion={() => this.setState({ modal: false })} titulo_accion='CERRAR' />
          <DialogContent style={{ padding: 0 }} className='scroll'>
            <Generica tipo={generica.tipo} persona={{ id: id_persona }} genericaRelacionId={generica.id} titulo="¡ Nuevo Permiso!" tituloInput="Permisos" tituloEliminar='¿ Eliminar Permiso ?' />
          </DialogContent>
          <DialogActions>
            <BtnForm texto="Cerrar" callback={() => this.setState({ modal: false })} />
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}


export default BienestarPermisos
